export default __webpack_public_path__ + "static/media/tfp-carousel-headline-box.e79b6526.png";